import script from "./InstitutionManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./InstitutionManagement.vue?vue&type=script&setup=true&lang=js"

import "./InstitutionManagement.vue?vue&type=style&index=0&id=7ece60c0&lang=scss"

const __exports__ = script;

export default __exports__